import { Box, Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import type { OpeningHours } from 'lib-shared-types-api';

import { ListItemHeader } from 'components/settings/components/sections/openingHours/components/listItemHeader/listItemHeader';

import styles from '../../listItem.module.scss';

type Props = {
  openingHours: OpeningHours;
  overrideException: OpeningHours;
  onChange: VoidFunction;
};

export const OverriddenItem = ({
  openingHours: {
    duration,
    name,
    next_date,
    opening_hour_type: openingHourType,
    recurring,
  },
  overrideException: { name: overrideName },
  onChange,
}: Props): JSX.Element => {
  return (
    <div className={classNames(styles.item, styles.itemOverridden)}>
      <ListItemHeader
        duration={duration}
        name={name}
        nextDate={next_date}
        openingHourType={openingHourType}
        recurring={recurring}
      />
      <Box height="60px" padding="10px 0 0">
        <Text.Paragraph wrap="nowrap">
          The business hours from {overrideName} apply to this date.
        </Text.Paragraph>
      </Box>
      <FlexBox justifyContent="flex-end">
        <Button
          className={styles.overrideButton}
          variant="secondary"
          onClick={() => {
            ampli.businessHoursScheduleConflictChangeButtonClicked();
            onChange();
          }}
        >
          Change
        </Button>
      </FlexBox>
    </div>
  );
};
